const filaVirtualInitialState = {
    filaVirtual: {
      data: null,
      loading: false,
      error: false,
    },
  };
  
  export default filaVirtualInitialState;